import React from 'react'

import { TagComponent, Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number } from 'prop-types'

const CONFIG = {
  participating: {
    color: 'positive',
    type: 'ghost',
    label: 'Participating',
    tooltip: 'This model is included in the subscription program',
  },
  eligible: {
    color: 'primary',
    type: 'ghost',
    label: 'Eligible',
    tooltip: 'This model meets the requirements for subscription',
  },
}

function getStatus(subscriptionSubscribed, subscriptionPotential) {
  if (subscriptionSubscribed) return 'participating'
  if (subscriptionPotential) return 'eligible'
  return null
}

function SubscriptionStatusTag({ itemId, subscriptionSubscribed = false, subscriptionPotential = false }) {
  const status = getStatus(subscriptionSubscribed, subscriptionPotential)
  const config = CONFIG[status]
  if (!config) return null

  return (
    <Tooltip
      id={`subscription-status-${status}-${itemId}`}
      content={config.tooltip}
      place="top"
    >
      <TagComponent color={config.color} type={config.type}>
        {config.label}
      </TagComponent>
    </Tooltip>
  )
}

SubscriptionStatusTag.propTypes = {
  itemId: number.isRequired,
  subscriptionSubscribed: bool,
  subscriptionPotential: bool,
}

export default SubscriptionStatusTag
